<template>
  <div class="editable-cell" @click.stop>
    <div v-if="editable" class="editable-cell-input-wrapper">
      <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
        type="check"
        class="editable-cell-icon-check"
        @click.stop="check"
      />
    </div>
    <div v-else class="editable-cell-text-wrapper">
      {{ value || ' ' }}
      <a-icon type="edit" class="editable-cell-icon" @click.stop="edit" />
    </div>
  </div>
</template>

<script>
import { Icon, Input } from 'ant-design-vue'

export default {
  components: {
    'a-icon': Icon,
    'a-input': Input
  },
  props: {
    text: String
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    }
  }
}
</script>

<style scoped>
.editable-cell:hover .editable-cell-icon {
  opacity: 1;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.editable-cell-text-wrapper {
  padding: 5px 0 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  width: 20px;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editable-cell-icon {
  line-height: 1;
  opacity: 0;
  margin-left: auto;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: var(--success-color);
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>
